class {
    onCreate() {
        this.state = {
            numOfRecords : new Map(),
            statusAndDisplayTextMap : { "LESS" : "查看更多...", "MORE" : "查看更少..." }
        }
    }

    onInput(input) {
        if (input && input.list) {
            input.list.forEach(element => this.state.numOfRecords.set(element.title, "LESS"));
        }
    }

    controlNumOfRecords(title, event) {
        const control = this.state.numOfRecords.get(title) == "LESS" ? "MORE" : "LESS";
        this.state.numOfRecords.set(title, control);

        this.forceUpdate();
        this.update();
    }
}

<if(input && input.list)>
    $ let resultMap = new Map();
    <for|site, index| of=input.list>
        $ {
            if(!resultMap.has(site.category)) {
                resultMap.set(site.category, []);
            }
            resultMap.get(site.category).push(site);
        }
    </for>

    <for|entry| of=resultMap.entries()>
        <div.category>
            <div.category-names>
                ${entry[0]}
            </div>
            <div.site-wrapper>
                <for|site, index| of=entry[1]>
                    $ let control = state.numOfRecords.get(site.title);
                    $ let total = control == "MORE" ? site.records.length : 8;
                    <div.one-site>
                        <details>
                            <summary>
                                <div.site-head>
                                    <div><a target="_blank" href=site.url>${site.title}</a></div>
                                </div>
                            </summary>
                            <div.site-body>
                                <if("ARTICLE" == site.itemType)>
                                    $ const sanitizeHtml = require('sanitize-html');
                                    <for|record, index1| of=site.records>
                                        <if(index1 < total)>
                                            <div.one-record>
                                                $ const sanitizedTitle = sanitizeHtml(record.title);
                                                <div.record-title><a target="_blank" href=record.url key="record-title[]">$!{sanitizedTitle}</a></div>
                                                $ const sanitizedDescription = sanitizeHtml(record.description);
                                                <div.record-description key="record-body[]">$!{sanitizedDescription}</div>
                                                <div.record-attrs>
                                                    <div>
                                                        <if(record.publisher)>
                                                            ${record.publisher}    
                                                        </if>
                                                    </div>
                                                    <div>
                                                        <if(record.publishDate)>
                                                            ${record.publishDate}
                                                        </if>
                                                    </div>
                                                </div>
                                            </div>
                                        </if>
                                    </for>
                                </if>
                                <else-if("VIDEO" == site.itemType || "PICTURE" == site.itemType)>
                                    <div.site-body-video>
                                        <for|record, index1| of=site.records>
                                            <if(index1 < total)>
                                                    <div.record-video>
                                                        <a target="_blank" href=record.url title=record.title>
                                                            <div.record-video-pic>
                                                                <img border="0" src=record.picUrl data-src=record.picUrl loading="lazy" onload=""  referrerpolicy="no-referrer">
                                                            </div>
                                                        </a>
                                                        <if(record.price)>
                                                            <div.record-price>
                                                                ${record.price}
                                                            </div>
                                                        </if>
                                                        <div.record-video-title>
                                                            <a target="_blank" href=record.url alt=record.description>$!{record.title}</a>
                                                        </div>
                                                        <div.record-video-attrs>
                                                            <div>
                                                                <if(record.publisher)>
                                                                    ${record.publisher}
                                                                </if>
                                                            </div>
                                                            <div>
                                                                <if(record.publishDate)>
                                                                    ${record.publishDate}
                                                                </if>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </if>
                                            </for>
                                        </div>
                                    </else-if>
                                    <div.more-record on-click("controlNumOfRecords", site.title)>
                                        ${state.statusAndDisplayTextMap[control]}
                                    </div>
                                </div>
                            </details>
                        </div>
                </for>
            </div>
        </div>
    </for>


</if>
